type VhsObject = {
  id: ID,
  node_id: ID | null,
  state?: string,
}
type VhsAction = (obj: VhsObject) => Promise<void> | void;
type VhsOperation = 'created' | 'updated' | 'deleted' | 'state.updated';

type SocketEvent = {
  kind: string,
  operation: VhsOperation,
  object: VhsObject
};

export const vhsNotificationHandler = (kind: string, actionMap: Partial<Record<VhsOperation, VhsAction>>) => async (event: SocketEvent) => {
  if (!event) {
    return Promise.resolve();
  }
  if (event.kind !== kind) {
    return Promise.resolve();
  }
  const action = actionMap[event.operation];
  if (action) {
    await action(event.object);
  }
  return Promise.resolve();
};

export default vhsNotificationHandler;
